import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConnectors2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconConnectors2"><Path d="M17 3C19.2091 3 21 4.79086 21 7C21 8.95272 19.6005 10.5776 17.75 10.9287V17.75H10.9287C10.5776 19.6005 8.95272 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C8.95272 13 10.5776 14.3995 10.9287 16.25H16.25V10.9287C14.3995 10.5776 13 8.95272 13 7C13 4.79086 14.7909 3 17 3Z" fill="currentColor"/><Path d="M7 3C9.20914 3 11 4.79086 11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConnectors2;
